export default "__VITE_ASSET__4aae4019__"